/** @module Sourcing/DeleteSupplier */
define([
	"dojo/_base/declare",
	"csi/xml",
	"./DeleteSRBase"
], function(declare,xml,DeleteSRBase) {

	return declare(DeleteSRBase, {

		/** @property to indicate if FDD is enabled in the SR */
		isFDDEnabled: false,

		/**
		 * Replace "Save" with "Remove" button
		 * @param {View} defView
		 * @param {Action[]} defActions
		 */
		addProxyActions: function(defView, defActions) {
			defActions.addAction(this.getProxyAction("BUTTON_REMOVE", true));
			this.inherited(arguments);
		},

		appendSupplierItemQuery: function(q) {
			this.inherited(arguments);
			q.RefAttr(this.getSourceRefAttribute(), xml.OP_EQUALS, this.m_urlNode, "Child:__Parent__")
			 .RefAttr("__Parent__", xml.OP_EQUALS, this.m_urlParent, "Child:QuoteSRLineItem");
		},

		appendSampleQuery: function(q) {
			this.inherited(arguments);
			 q.RefAttr(this.getSourceRefAttribute(), xml.OP_EQUALS, this.m_urlNode, "Child:__Parent__")
			 .RefAttr("__Parent__", xml.OP_EQUALS, this.m_urlParent, "Child:SampleSRLineItem");
		},

		/**
		 * Retunrs the source ref attribute name base on FDD enabled or not
		 */
		getSourceRefAttribute() {
			return this.isFDDEnabled ? "SupplierFactory" : "Supplier";
		}
	});
});
